import { Link } from 'react-router-dom';

import useStyles from './featured-brand-preview.styles';

const FeaturedBrandPreview = () => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div className={classes.title}>Featured Brand</div>
      <Link to="/shop" className={classes.link}>
        View all
      </Link>
      <div className={classes.previewContainer}>
        <div className={classes.previewItem}>Brand</div>
        <div className={classes.previewItem}>Brand</div>
        <div className={classes.previewItem}>Brand</div>
        <div className={classes.previewItem}>Brand</div>
        <div className={classes.previewItem}>Brand</div>
        <div className={classes.previewItem}>Brand</div>
        <div className={classes.previewItem}>Brand</div>
        <div className={classes.previewItem}>Brand</div>
      </div>
    </div>
  );
};

export default FeaturedBrandPreview;
